import { httpClient } from './httpClient';
import type {
  CreateClientRequest,
  UpdateClientRequest,
  GetClientsResponse,
  GetClientResponse,
  CreateClientResponse,
  UpdateClientResponse,
  MarkVisitsRequest,
} from './types';

interface QueryOptions {
  signal?: AbortSignal;
}

export const clientsApi = {
  getAll: (options?: QueryOptions): Promise<GetClientsResponse> => {
    return httpClient.get<GetClientsResponse>('/v1/clients', options);
  },

  getById: (clientId: string, options?: QueryOptions): Promise<GetClientResponse> => {
    return httpClient.get<GetClientResponse>(`/v1/clients/${clientId}`, options);
  },

  create: (data: CreateClientRequest): Promise<CreateClientResponse> => {
    return httpClient.post<CreateClientResponse>('/v1/clients', data);
  },

  update: (clientId: string, data: UpdateClientRequest): Promise<UpdateClientResponse> => {
    return httpClient.put<UpdateClientResponse>(`/v1/clients/${clientId}`, data);
  },

  delete: (clientId: string): Promise<void> => {
    return httpClient.delete<void>(`/v1/clients/${clientId}`);
  },

  markVisit: (clientId: string): Promise<void> => {
    return httpClient.post<void>(`/v1/clients/${clientId}/mark-visit`, undefined);
  },

  markVisits: (data: MarkVisitsRequest): Promise<void> => {
    return httpClient.post<void>('/v1/clients/mark-visits', data);
  },
} as const;
